import PowerIcon from '@atlaskit/icon-lab/core/power';
import React from 'react';

export function SvgPower() {
  return <PowerIcon label="" testId="ads-refreshed-icon" />;
}
